import React, { useEffect } from "react";

import { Col, Container, Button, Row } from "reactstrap";

import { connect } from "react-redux";
import { requestClass } from "../../../redux/actions/class_request_form";
import { fetchSubjectsByQualification } from "../../../redux/actions/api_subject";
import { createLoadingSelector } from "../../../redux/selectors";

import ImageJumbotron from "../../../components/ImageJumbotron";
import PackageCard from "../../../components/PackageCard";
import BottomBar from "../../../components/BottomBar";
import { Bell } from "react-feather";
import { getQualId } from "../../../helpers/qualificationIdentifier";

import Loader from "../../../components/Loader";

const Uniadm = ({
  fetchSubjectsByQualification,
  requestClass,
  history,
  isLoading,
  subjects,
}) => {
  useEffect(() => {
    const id = getQualId("uniadm");
    fetchSubjectsByQualification(id);
  }, [fetchSubjectsByQualification]);

  const handleClick = () => {
    requestClass({ id: getQualId("uniadm"), name: "University Tests" });
    history.push("/page/class/request");
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <ImageJumbotron bg="banner.jpg">
        <Container className="product_container">
          <Row>
            <Col md={6} sm={12}>
              <h1>BMAT, LNAT, MAT, STEP, ...</h1>
              <h4>1:1 Online Class</h4>
              <p>
                전반적으로 명문대학을 목표로 하는 학생들은 8 – 11개의 과목을
                수료하고, 이 과정은{" "}
                <span className="highlight">
                  A-Level을 공부하기 위한 기반이 됩니다
                </span>
                .
              </p>
              <p>
                저희 <span className="highlight">오버더문</span>에서는{" "}
                <span className="highlight">맞춤형 컨설팅</span>을 통해 학생의{" "}
                <span className="highlight">특성, 목표 대학교, 장래희망</span>
                등을 고려해서{" "}
                <span className="highlight">강사님을 매칭해드립니다.</span>
              </p>
              <p>
                해외 곳곳에 위치한{" "}
                <span className="highlight">명문대 출신</span> 강사님들을 통해
                <span className="highlight"> 1:1 맞춤형</span> 온라인 강의를
                받아보세요.
              </p>
            </Col>
            <Col md={6} sm={12}>
              <PackageCard
                subjects={subjects}
                qualification="IGCSE"
                classMethod="비대면"
                targetAudience="중학생 (2,3학년)"
                onClick={handleClick}
              />
            </Col>
          </Row>
        </Container>
      </ImageJumbotron>
      <BottomBar>
        <Row>
          <Col md={8} sm={12}>
            <div className="d-inline-block">
              <Bell style={{ position: "relative", bottom: "10" }} />
            </div>
            <div className="d-inline-block pl-2">
              <p style={{ fontWeight: "700" }}>
                EARLY BIRD <span style={{ fontWeight: "900" }}>20%</span> 특별
                할인 이벤트!
              </p>
              <p style={{ fontSize: "0.9rem" }}>
                8월 24일 전에 신청하시면 할인 혜택을 받으실수 있습니다.
              </p>
            </div>
          </Col>
          <Col md={4} sm={12}>
            <Button
              color="danger"
              style={{ width: "100%" }}
              onClick={handleClick}
            >
              수강 신청하기
            </Button>
          </Col>
        </Row>
      </BottomBar>
      <div className="site-section mt-0 pt-4">
        <Container className="class-page">
          <div className="sub-section">
            <h2>상담 문의</h2>
            <hr />
            <p className="text-center">
              <a
                href="https://pf.kakao.com/_xdNrsT"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={require("../../../assets/img/kakaoplus.png")}
                  className="img-fluid"
                  alt="kakaoplus"
                />
              </a>
            </p>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

const loadingSelector = createLoadingSelector(["FETCH_SUBJECTS"]);

const mapStateToProps = (state) => ({
  isLoading: loadingSelector(state),
  subjects: state.api_subject.subjects,
});

const mapDispatchToProps = (dispatch) => ({
  requestClass: (class_type) => dispatch(requestClass(class_type)),
  fetchSubjectsByQualification: (qualification) =>
    dispatch(fetchSubjectsByQualification(qualification)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Uniadm);
